import { toast, Bounce } from 'react-toastify';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';

export const platform = 'Web';
export const admin_prefix = process.env.REACT_APP_ADMIN_PREFIX;
export const common_prefix = '/';
export const home_url = process.env.REACT_APP_HOME_URL;
export const image_url = process.env.REACT_APP_IMAGE_URL;
export const API_URL = process.env.REACT_APP_API_URL;
export const adminBaseProfileURL = process.env.REACT_APP_IMAGE_URL;
export const PUBLIC_URL = process.env.PUBLIC_URL;
export const type = {
    admin: 1,
    buyer: 2,
    salesman: 3,
    driver: 4,
    officeAdmin: 5,
};
export const saurbhiToast = toast;
export const saurbhiBounce = Bounce;
export const toastView = '';
export const MySwal = withReactContent(Swal);
export const messaging = '';
export const GetLocation = '';
export const CHART_COLORS = [
    '#7367f0',
    '#e9b20d',
    '#2e6480',
    '#d4474e',
    '#33a543',
    '#57c7d4',
    '#749F10',
    '#199F10',
    '#109F58',
    '#109F94',
    '#105C9F',
];
export const allowOnlyDigitRegex = /^[0-9\b]+$/;
export const productWeightOptions = [
    { label: 'Gm', value: 'Gm' },
    { label: 'Kg', value: 'Kg' },
    { label: 'Lt', value: 'Lt' },
    { label: 'Ml', value: 'Ml' },
];

export const tableScroll = () => {
    const ele: any = document.querySelector('.scrollableTable');
    let tableScroll: any;

    if (ele) {
        tableScroll = ele.childNodes[0];
    }

    let isDown: any = false;
    let startX: any;
    let scrollLeft: any;

    if (tableScroll) {
        tableScroll.addEventListener('mousedown', (e: any) => {
            isDown = true;
            startX = e.pageX - tableScroll.offsetLeft;
            scrollLeft = tableScroll.scrollLeft;
        });
        tableScroll.addEventListener('mouseleave', () => {
            isDown = false;
        });
        tableScroll.addEventListener('mouseup', () => {
            isDown = false;
        });
        tableScroll.addEventListener('mousemove', (e: any) => {
            if (!isDown) return;
            e.preventDefault();
            const x = e.pageX - tableScroll.offsetLeft;
            const walk = x - startX;
            tableScroll.scrollLeft = scrollLeft - walk;
        });
    }
};

export const addTablePadding = (index: number) => {
    const tableBody: any = document.querySelector('#calulatorTable .rdt_TableBody');

    let tableCount = 0;

    if (tableBody) {
        tableCount = tableBody.childElementCount;
    }
    if (tableCount - index < 5 && tableBody) {
        tableBody.lastElementChild.style.paddingBottom = `${200 - (tableCount - (index + 1)) * 25}px`;
    }
};

export function intToString(value: any) {
    var suffixes = ['', 'k', 'm', 'b', 't'];
    var suffixNum = Math.floor(('' + value).length / 3);
    var shortValue: any = parseFloat((suffixNum !== 0 ? value / Math.pow(1000, suffixNum) : value).toPrecision(2));
    if (shortValue % 1 !== 0) {
        shortValue = shortValue.toFixed(1);
    }
    return shortValue + suffixes[suffixNum];
}

export const DISCOUNT_OFFER_USER_GROUP_SELECTION_TYPE = {
    INCLUDE: 'include',
    EXCLUDE: 'exclude',
};

export const DISCOUNT_TYPES = {
    FLAT: '1',
    BUY_GET: '2',
    BUY_GET_RECURRING: '3',
};

// export const states = [
//     { label: 'NSW', value: 'NSW' },
//     { label: 'VIC', value: 'VIC' },
//     { label: 'ACT', value: 'ACT' },
// ];
